import { useState } from 'react';
import cn from 'classnames';
import { ISelectOption } from 'interfaces';

import { Tree } from 'components/Tree';
import { Node } from 'components/Tree/Node';

import TextInput from '../TextInput';

import {
  Theme,
  TreeSelectOptionNodeData,
  TreeSelectOptionNodeEntity,
} from './types';
import { renderNodeIcon, searchMatch } from './utils';

export interface TreeSelectDropdownProps<T, P> {
  data: TreeSelectOptionNodeData<T, P>[];
  placeholder?: string;
  search?: boolean;
  theme?: Theme;
  classNames?: { container?: string };
  onSelect: (value: T, option: ISelectOption<T, P>) => void;
}

export const TreeSelectDropdown = <T, P>({
  data,
  search,
  placeholder = 'Поиск',
  theme,
  classNames,
  onSelect,
}: TreeSelectDropdownProps<T, P>) => {
  const [searchValue, setSearchValue] = useState('');

  return (
    <div
      className={cn(
        'rounded-[10px] bg-ultrablack border border-solid border-dark_product',
        classNames?.container
      )}
    >
      {search && (
        <TextInput
          value={searchValue}
          placeholder={placeholder}
          searchIcon
          size="m"
          theme={theme}
          classNames={{
            container:
              'border-b border-solid border-dark_product rounded-t-[inherit] overflow-hidden',
            input: 'rounded-b-none tpg-c2',
          }}
          onChange={setSearchValue}
        />
      )}
      <div className="pl-4 py-1">
        <Tree<
          TreeSelectOptionNodeEntity<T, P>,
          TreeSelectOptionNodeEntity<T, P>
        >
          data={data}
          searchTerm={searchValue}
          searchMatch={searchMatch}
          height={285}
        >
          {(nodeRendererProps) => (
            <Node<
              TreeSelectOptionNodeEntity<T, P>,
              TreeSelectOptionNodeEntity<T, P>
            >
              alignBy="space"
              className="flex justify-center items-center w-full h-full pr-4"
              renderIcon={renderNodeIcon}
              onClick={(e, node) =>
                onSelect(node.data.entity.value, node.data.entity)
              }
              {...nodeRendererProps}
            />
          )}
        </Tree>
      </div>
    </div>
  );
};
